export function getFirstNameLastInital(studentName: string) {
  const fullName = studentName.split(' ');
  return fullName.length > 0
    ? `${fullName[0]} ${fullName[1] ? fullName[1].slice(0, 1) : ''}`.trim()
    : undefined;
}

export function getCoachTitle(coachFullName: string) {
  return `${coachFullName.split(' ')[0]}`;
}
